export default {
  colors: {
    white: '#ffffff',
    mustard: '#f2c93f',
    blue: '#3993CB',
    basic: '#F7F6F2',
  },
};
